import { createConfiguratorUrl } from "src/RouteUrls";
import { Css } from "~generated/css";
import { CheckoutConfigStatus, Maybe } from "~generated/graphqlTypes";
import { dateFormatter, useTestIds } from "~utils";
import { FlowStep } from "../../configurator/stepTemplates";

function DateRow({ label, date, isRed }: { label: string; date: Maybe<Date>; isRed?: boolean }) {
  if (!date) return null;
  return (
    <div>
      {label}: <span css={isRed ? Css.fw500.red600.$ : Css.fw500.$}>{dateFormatter(date, "MMMM d, yyyy")}</span>
    </div>
  );
}

type PrintHeaderProps = {
  status: CheckoutConfigStatus;
  createdAt: Maybe<Date>;
  reservedAt: Maybe<Date>;
  configurationName?: string | null;
  expiredAt: Maybe<Date>;
  customerEmail: Maybe<string>;
  checkoutConfigId: string;
  communityId: string;
};

export const PrintHeader = (props: PrintHeaderProps) => {
  const tid = useTestIds(props, "printHeader");
  const { status, createdAt, reservedAt, configurationName, expiredAt, customerEmail, checkoutConfigId, communityId } =
    props;
  const [isDraft, isExpired] = [CheckoutConfigStatus.Draft, CheckoutConfigStatus.Expired].map((s) => status === s);
  // Absolute URL so the link still resolves when the exported PDF is opened outside the app.
  const summaryUrl = `${window.location.origin}${createConfiguratorUrl(communityId, checkoutConfigId, FlowStep.Summary)}`;
  return (
    <>
      <div css={Css.z1.w100.df.fg1.aic.jcsb.my1.$} {...tid}>
        <img width="153" height="26" src="/logo.svg" alt="Homebound" />
      </div>
      <div css={Css.df.w100.jcsb.t16.gray800.fw200.$}>
        <div css={Css.df.fdc.gap1.$}>
          <div>
            Build: <span css={Css.t18.fw500.$}>{configurationName ?? "Custom"}</span>
          </div>
          {isDraft && <div css={Css.fw500.red600.$}>Pricing Not Reserved</div>}
          {customerEmail && (
            <div>
              Homeowner Email: <span css={Css.fw500.$}>{customerEmail}</span>
            </div>
          )}
          <div css={Css.df.fdc.gap1.$}>
            {isDraft && <DateRow label="Created" date={createdAt} />}
            {!isDraft && <DateRow label="Reserved" date={reservedAt} />}
            {!isDraft && <DateRow label={`Expire${isExpired ? "d" : "s"}`} date={expiredAt} isRed />}
            <div>
              Config ID:{" "}
              <a {...tid["configLink"]} href={summaryUrl} css={Css.fw500.tdu.blue700.$}>
                {checkoutConfigId.replace(/\D/g, "")}
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
